import { useEffect, useState } from "react";
import PageBreadcrumbs from "../layouts/PageBreadcrumbs.js";
import { SkeletonTable } from "../components/Skeleton.js";
import { api, ApiError, loadSession } from "../lib/api.js";

type SupportState = Awaited<ReturnType<typeof api.workspaceSupport>>;

export default function Support() {
  const session = loadSession();
  const workspaceId = session?.workspaceId ?? "";
  const [data, setData] = useState<SupportState | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!workspaceId) { setLoading(false); return; }
    let cancelled = false;
    api.workspaceSupport(workspaceId)
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e: unknown) => { if (!cancelled) setError(e instanceof ApiError ? e.message : String(e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [workspaceId]);

  if (!workspaceId) {
    return <div className="page"><div className="alert alert-error">No workspace in session.</div></div>;
  }

  return (
    <div className="page">
      <PageBreadcrumbs />
      <header className="page-head">
        <div>
          <h1>Support center</h1>
          <p>Workspace health at a glance. Surface this to support staff when a customer opens a ticket.</p>
        </div>
      </header>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? <SkeletonTable rows={5} columns={4} /> : data && (
        <>
          <section className="kpi-row">
            <div className="kpi"><div className="kpi-label">Workspace</div><div className="kpi-value">{data.workspaceName}</div></div>
            <div className="kpi"><div className="kpi-label">Status</div><div className="kpi-value">{data.status}</div></div>
            <div className="kpi"><div className="kpi-label">Seats</div><div className="kpi-value">{data.seats}</div></div>
            <div className="kpi"><div className="kpi-label">DHIS2 connections</div><div className="kpi-value">{data.dhis2Connections}</div></div>
            <div className="kpi"><div className="kpi-label">Healthy connections</div><div className="kpi-value">{data.connectionsHealthy}</div></div>
          </section>

          <section>
            <h2>Onboarding checklist</h2>
            <ul className="checklist">
              {data.onboardingChecklist.map((item) => (
                <li key={item.key} className={item.done ? "done" : "pending"}>
                  <span className={item.done ? "pill pill-ok" : "pill pill-muted"}>{item.done ? "Done" : "Pending"}</span>
                  &nbsp;{item.label}
                </li>
              ))}
            </ul>
          </section>
        </>
      )}
    </div>
  );
}
